import { dynamicApiSlice } from "@/app/dynamicApi";
import type { FileMetadataResponse } from "@/types/FileMetadata";

export const filesApi = dynamicApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadFile: builder.mutation<string, FormData>({
      query: (formData) => ({
        url: "files",
        method: "POST",
        body: formData,
      }),
    }),
    removeFile: builder.mutation<void, string>({
      query: (fileId) => ({
        url: `files/${fileId}`,
        method: "DELETE",
      }),
    }),
    getFileMetadata: builder.query<FileMetadataResponse, { id: string }>({
      query: ({ id }) =>
        `files/metadata/${id}`,
      transformResponse: (response: FileMetadataResponse) => response,
    }),
    getFileBlob: builder.query<File, { id: string, fileName: string }>({
      query: ({ id }) =>
        `files/metadata/${id}`,
      transformResponse: async (response: Response, meta, arg) : Promise<File> => {
        console.log(meta);
        const blob = await response.blob();
        const contentType =
          response.headers.get("content-type") || "application/octet-stream";
        let fileName = arg.fileName;
        return new File([blob], fileName, { type: contentType });
      },
    }),
  }),
});

export const { useUploadFileMutation, useRemoveFileMutation, useGetFileMetadataQuery, useGetFileBlobQuery } = filesApi;
